"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERVAL = exports.COMPARISON_PERIOD = exports.DATETIME_PERIODS = void 0;
var DATETIME_PERIODS;
(function (DATETIME_PERIODS) {
    DATETIME_PERIODS["DAY"] = "TODAY";
    DATETIME_PERIODS["YESTERDAY"] = "YESTERDAY";
    DATETIME_PERIODS["WEEK"] = "WTD";
    DATETIME_PERIODS["WEEKMTS"] = "WTDMTS";
    DATETIME_PERIODS["LAST30"] = "LAST30";
    DATETIME_PERIODS["MTD"] = "MTD";
    DATETIME_PERIODS["CURRENTMONTH"] = "CURRENTMONTH";
    DATETIME_PERIODS["LASTMONTH"] = "LASTMONTH";
    DATETIME_PERIODS["CURRENTQ"] = "CURRENTQ";
    DATETIME_PERIODS["LASTQ"] = "LASTQ";
    DATETIME_PERIODS["LAST12"] = "LAST12";
    DATETIME_PERIODS["YEAR"] = "YTD";
    DATETIME_PERIODS["CURRENTYEAR"] = "CURRENTYEAR";
    DATETIME_PERIODS["CUSTOM"] = "CUSTOM";
})(DATETIME_PERIODS = exports.DATETIME_PERIODS || (exports.DATETIME_PERIODS = {}));
var COMPARISON_PERIOD;
(function (COMPARISON_PERIOD) {
    COMPARISON_PERIOD["THISYEAR"] = "THISYEAR";
    COMPARISON_PERIOD["LASTYEAR"] = "LASTYEAR";
    COMPARISON_PERIOD["PREVIOUSFISCALPERIOD"] = "PREVIOUSFISCALPERIOD";
})(COMPARISON_PERIOD = exports.COMPARISON_PERIOD || (exports.COMPARISON_PERIOD = {}));
var INTERVAL;
(function (INTERVAL) {
    INTERVAL["YEARS"] = "y";
    INTERVAL["QUARTERS"] = "Q";
    INTERVAL["MONTHS"] = "M";
    INTERVAL["WEEKS"] = "w";
    INTERVAL["DAYS"] = "d";
    INTERVAL["HOURS"] = "h";
})(INTERVAL = exports.INTERVAL || (exports.INTERVAL = {}));
//# sourceMappingURL=dateTime.js.map